/*
 * Copyright (C) 2018 - 2023. Entgra (Pvt) Ltd, https://entgra.io
 * All Rights Reserved.
 *
 * Unauthorized copying/redistribution of this file, via any medium
 * is strictly prohibited.
 * Proprietary and confidential.
 *
 * Licensed under the Entgra Commercial License,
 * Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 *
 * You may obtain a copy of the License at
 * https://entgra.io/licenses/entgra-commercial/1.0
 */

import winEnrollStep01 from '../../../../../../../../../../../public/images/win_enroll_step_01.png';
import winEnrollStep02 from '../../../../../../../../../../../public/images/win_enroll_step_02.png';
import winEnrollStep03 from '../../../../../../../../../../../public/images/win_enroll_step_03.png';

export const windowsEnrollmentSteps = t => {
  return [
    {
      title: t('label_access_work_or_school'),
      prerequisites: [t('label_windows_device')],
      stepInfos: [
        {
          title: t('label_access_relevant_settings'),
          description: t('description_windows_enrollment_step01_step_info01'),
        },
      ],
      stepImg: winEnrollStep01,
    },
    {
      title: t('label_enroll_only_in_device_management'),
      description: t('description_windows_enrollment_step02'),
      stepInfos: [
        {
          title: t('label_enter_the_email'),
          description: t('description_windows_enrollment_step02_step_info01'),
          copyables: [
            {
              key: t('eg'),
              value: 'admin@dev.abc.com',
            },
          ],
        },
        {
          title: t('label_optional_enter_the_mdm_server_url'),
          description: t('description_windows_enrollment_step02_step_info02'),
          copyables: [
            {
              key: t('eg'),
              value: 'enterpriseenrollment.dev.abc.com',
            },
          ],
        },
      ],
      stepImg: winEnrollStep02,
    },
    {
      title: t('label_log_in_to_entgra_uem_server'),
      stepInfos: [
        {
          title: t('label_enter_the_credentials'),
          description: t('description_windows_enrollment_step03_step_info01'),
        },
        {
          title: t('label_accept_the_license_agreement'),
          description: t('description_windows_enrollment_step03_step_info02'),
        },
      ],
      stepImg: winEnrollStep03,
    },
  ];
};
